export default __webpack_public_path__ + "static/media/logo.cced027b.png";